import styled from 'styled-components';
import Popover from 'react-popover';

import {
  Flex,
} from 'web-styled';

export const StyledPopover = styled(Popover)`
  z-index: 9999;
  & > .Popover-tip {
    fill: ${(props) => {
    switch (props.theme) {
      case 'light':
        return 'rgba(255, 255, 255, 0.9)';
      case 'dark':
        return 'rgba(17, 17, 17, 0.9)';
      default:
        return '';
    }
  }}
  }
`;

export const Body = styled(Flex)`
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-family: sans-serif !important;
  text-align: center !important;
  align-items:center;
  justify-content: center;
  text-shadow: none !important;
  width: ${props => props.width || '150px'};
  padding: .5em 1em;
  border-radius: 4px;

  ${(props) => {
    switch (props.theme) {
      case 'light':
        return `
            color: #000;
            background: rgba(255, 255, 255, 0.9);
          `;
      case 'dark':
        return `
            color: #fff;
            background: rgba(17, 17, 17, 0.9);
          `;
      default:
        return '';
    }
  }}
`;
